import { render, staticRenderFns } from "./selectPage.vue?vue&type=template&id=2a03e5f9&"
import script from "./selectPage.vue?vue&type=script&lang=ts&"
export * from "./selectPage.vue?vue&type=script&lang=ts&"
import style0 from "./selectPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports